<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <div *ngIf="submited" class="alert alert-success" role="alert">
        <em>Dziękujemy za kontakt! Wiadomość została wysłana.</em>
      </div>
      <form class="form-horizontal" (ngSubmit)="onSubmit()" #f="ngForm">
        <!-- Name input-->
        <div class="form-group">
          <input id="name" name="name" [(ngModel)]="model.name" type="text" placeholder="Twoje imię i nazwisko" class="form-control" required>
        </div>

        <!-- Email input-->
        <div class="form-group">
          <input id="email" name="email" [(ngModel)]="model.email" type="text" placeholder="Twój e-mail" class="form-control" type="email" required>
        </div>

        <!-- Message body -->
        <div class="form-group">
          <textarea class="form-control" id="message" name="message" [(ngModel)]="model.body" placeholder="Wprowadź Twoje zapytanie tutaj"
            rows="5" required></textarea>
        </div>
        <div class="form-group">
          <app-recaptcha (notify)="captchaResolved($event)"></app-recaptcha>
        </div>
        <!-- Form actions -->
        <div class="form-group">
          <button type="submit" class="btn btn-primary btn-lg" [disabled]="!isCaptchaSolved || !f.form.valid">Wyślij wiadomość</button>
        </div>
      </form>


    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/contact-form/contact-form.component.html